
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetActivatedFilled as ObiAisTargetActivatedFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-activated-filled.js';
 
 
 

 
 export const ObiAisTargetActivatedFilled = createComponent({
   react: React,
   tagName: 'obi-ais-target-activated-filled',
   elementClass: ObiAisTargetActivatedFilledElement,
   events: {
     
   }
  });
 
 